import { render, staticRenderFns } from "./DocumentAttachmentPreview.vue?vue&type=template&id=9b3c1442&scoped=true&"
import script from "./DocumentAttachmentPreview.vue?vue&type=script&lang=ts&"
export * from "./DocumentAttachmentPreview.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentAttachmentPreview.vue?vue&type=style&index=0&id=9b3c1442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3c1442",
  null
  
)

export default component.exports